module.exports = __webpack_public_path__ + "img/wrong.417dc3d7.png";